module.exports = __webpack_public_path__ + "static/media/signet.a7067499.png";